import React, {useEffect, useState} from "react";
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix default marker icon issue in some setups (e.g. Vite, Next.js)
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import ModalDefault from "../../modal-default";
import MapCanvas from "./map-canvas";

const DefaultIcon = L.icon({
    iconUrl,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

export default function MapDialog({mapData, mapCenter, onClose, areMarkerClustered = true, translate}) {
    const [showModal, setShowModal] = useState(false);
    const [showMap, setShowMap] = useState(false);

    useEffect(() => {
        setShowModal(true);
        setTimeout(() => {
            setShowMap(true);
        }, 400)
    }, [setShowMap])

    const title = [
        [
            [mapData.LocationName, mapData.AddressName].filter(it => !!it).join(" - "),
            mapData.CityName
        ].filter(it => !!it).join(" "),
        [mapData.State, mapData.PostalCode].filter(it => !!it).join(" ")
    ].filter(it => !!it).join(", ")

    return (
        <ModalDefault
            show={showModal}
            title={
                <span className="text-xl font-bold truncate mr-6 text-tm-gray-900">
                    {translate("text.map_location")}
                    {!!title && (<span
                        className={"text-small display-inline ml-3"}>
                        {title}
                    </span>)}
                </span>
            }
            widthClass={"w-screen max-w-full"}
            hideDialogFooter={true}
            onClose={onClose}
            closeButtonLabel={translate("btn.close")}
            translate={translate}
        >
            <div className="h-screen max-h-[calc(100vh-8rem)]">
                {showMap && (
                    <MapCanvas
                        data={mapData}
                        center={mapCenter}
                        areMarkerClustered={areMarkerClustered}
                    />
                )}
            </div>
        </ModalDefault>
    );
}